import { GbgrundbuchgeschaeftService, GrundbuchgeschaeftSearchRequestStandardMeta } from '../../../../core/gb-api';
import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { submit } from '../grundbuchgeschaeft.functions';
import { GbGemeindeSearchMode as GbGemeindeSearchMode } from '../../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { TagebuchNummerComponent } from '../../../../shared/widgets/tagebuch-nummer/tagebuch-nummer.component';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { RechtsgueltigHaengigComponent } from '../../../../shared/widgets/tagebuchstatus-selection/tagebuchstatus-selection.component';
import { GrundstueckNummerComponent } from '../../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { EgridValidatorDirective } from '../../../../shared/directives/egrid-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundbuchgeschaeft-suche-standard',
  templateUrl: './grundbuchgeschaeft-suche-standard.component.html',
  styleUrls: ['./grundbuchgeschaeft-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    TagebuchNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    RechtsgueltigHaengigComponent,
    GrundstueckNummerComponent,
    CapFormRowDirective,
    CapFormControlComponent,
    EgridValidatorDirective,
    TranslatePipe
  ]
})
export class GrundbuchgeschaeftSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnChanges, OnDestroy {
  standard: GrundbuchgeschaeftSearchRequestStandardMeta;

  @ViewChild(TagebuchNummerComponent, { static: false })
  private tbNummer: TagebuchNummerComponent;

  @ViewChild('form', { static: false })
  form: NgForm;

  gbGemeindeSearchMode = GbGemeindeSearchMode.GRUNDBUCHGESCHAEFT_SEARCH;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private grundbuchgeschaeftService: GbgrundbuchgeschaeftService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.grundbuchgeschaeftService.searchGbGeschaeftStandardTemplate().subscribe((template) => {
      this.standard = this.copyLastRequest(template);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.standard;
    submit(this.form, SearchMode.searchStandard, this.standard, this.router, this.route);
  }

  trim(inputValue) {
    if (this.standard && this.standard.egrid) {
      // .trim() seems not to work
      return inputValue.toString().replace(/\s/g, '');
    }
  }

  onReset(): void {
    this.form.reset();
    this.subscription = this.grundbuchgeschaeftService.searchGbGeschaeftStandardTemplate().subscribe((template) => {
      this.standard = template;
      this.tbNummer.focus();
      this.tbNummer.onReset();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // required for egrid-trim
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
